(function() {
	/*
	 * Fundly Campaign Widget
     *
     * Attributes:
     *  @fundlyurl - Fundly campaign URL
     *
     * Usage: <fundly-campaign fundlyurl="s.fundlyurl"></fundly-campaign>
	 */
	SUGApp.directive('fundlyCampaign', [ '$sce', '$timeout', function ( $sce, $timeout ) {
		return {
			restrict: 'E',
            templateUrl: '/view/templates/ngtemplates/fundly-campaign.html',
			scope: {
                fundlyurl: '@'
            },
			link: function(scope, element, attrs) {

                // variables
                scope.iframesrc = '';
                scope.viewurl = '';
                var slug = '';
                // set text elements (no longer used)
                scope.str = {
                    poweredby:  'Powered by SignUpGenius Donations',
                    viewlink:   'View Campaign',
                };
				// this runs first
				function init(){
                    slug = getSlug();
                    scope.iframesrc = $sce.trustAsResourceUrl( getiFrameSrc() );
                    scope.viewurl = $sce.trustAsResourceUrl( getViewUrl() );
				}
                /**
                 * Parse slug from url. Url can look like
                 * 'https://fundly.com/signupgenius-test-campaign'
                 * or 'https://giving.signupgenius.com/signupgenius-test-campaign'
                 * or 'https://donations.signupgenius.com/signupgenius-test-campaign'
                 */
                function getSlug(){
                    const campaignurl = new URL( angular.copy( scope.fundlyurl ) );
                    // return everything after the domain (pathname) and initial / (replace regex)
                    return campaignurl.pathname.replace(/^\//, '');
                }
                /**
                 * Identifies the campaign source
                 */
                function getCampaignSource() {
                    var campaignSource = {
                        isDonations: false,
                        isGiving: false,
                        isFundly: false
                    }
                    var url = angular.copy( scope.fundlyurl );
                    var containsFundlyURL = url.includes('https://fundly.com/') || url.includes('https://fundly.net/');
                    var containsGivingURL = url.includes('https://giving.signupgenius.com/') || url.includes('https://giving.signupgenius.rocks/');
                    var containsDonationsURL = url.includes('https://donations.signupgenius.com/') || url.includes('https://donations.signupgenius.rocks/');

                    if(containsFundlyURL){
                        campaignSource.isFundly = true;
                    } else if(containsGivingURL){
                        campaignSource.isGiving = true;
                    } else if(containsDonationsURL){
                        campaignSource.isDonations = true;
                    }
                    return campaignSource;
                }
                /**
                 * Create iFrame source from slug
                 */
                function getiFrameSrc(){
                    var campaignSource = getCampaignSource();
                    var fundlyCardHost = 'https://d2wwhrh9otv6z9.cloudfront.net';
                    var campaignCardHost = window.globalcfg?.solutions?.donations?.campaignCardHost;

                    return `${campaignSource.isFundly ? fundlyCardHost : campaignCardHost }/campaign_card_v2.html?activity=` + slug + '&amp;hb=t';
                }
                /**
                 * Create view link url from slug
                 */
                function getViewUrl(){
                    return scope.fundlyurl + '?ft_src=sug_campaign_card';
                }

                // fire init
				init();
            }
        };
    }]);

}());
